import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=a38680ec&"
import script from "./surface_title.vue?vue&type=script&lang=js&"
export * from "./surface_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports